import React, { useEffect, useState } from "react";
import { doc, onSnapshot} from "firebase/firestore";
import { db } from "../firebase";
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';


const DownloadResult = () => {
    const location = useLocation();
    const [studentResultDetails, setStudentResultDetails] = useState([]);

    useEffect(() => {
        onSnapshot(doc(db, "resultStudent", location.state.resultId), (doc) => {
            let array=[]
            array.push({id:doc.id,...doc.data()})
            setStudentResultDetails(array);
        });
        }, []);



        const showGradeTerm1 = (marks)=> {
  
          if (marks < 33) {
            return "Fail"
          } else if (marks >= 33 && marks < 40) { 
            return "D"
          } else if (marks >= 40 && marks < 50) {
            return "C2"
          }else if (marks >= 50 && marks < 60) {
            return "C1"
          }else if (marks >= 60 && marks < 70) {
            return "B2"
          }else if (marks >= 70 && marks < 80) {
            return "B1"
          }else if (marks >= 80 && marks < 90) {
            return "A2"
          }else if (marks >= 90 && marks < 100) {
            return "A1"
          } else {
            return "N/A"
          }
        }
      
       
        const showTotalGradeTerm1 = (marks)=> {
          if (marks < 198) {
            return "Fail"
          } else if (marks >= 198 && marks < 240) {
            return "D"
          } else if (marks >= 240 && marks < 300) {
            return "C2"
          }else if (marks >= 300 && marks < 360) {
            return "C1"
          }else if (marks >= 360 && marks < 420) {
            return "B2"
          }else if (marks >= 420 && marks < 480) {
            return "B1"
          }else if (marks >= 480 && marks < 540) {
            return "A2"
          }else if (marks >= 540 && marks < 600) {
            return "A1"
          } else {
            return "N/A"
          }
        }

        const downloadResult=()=>{
          var doc = new jsPDF('p','mm','a4');
           var img = new Image()
            var imgData =new Image()
            imgData.src = '../../assets/sail.png'
             img.src = '../../assets/as_logo.png'
            doc.addImage(img, 'png', 172, 12, 25, 25)
            doc.addImage(imgData, 'png', 10, 12, 25, 25)
            doc.setFontSize(15);
            doc.text(38, 18, 'BOKARO ISPAT SENIOR SECONDARY SCHOOL - 8B');
      
            doc.setFontSize(12);
            doc.text(65, 25, 'BOKARO STEEL CITY, JHARKHAND');

            doc.setFontSize(11);
            doc.setFont("helvetica");
            doc.text(70, 32, "Academic Session :");
            doc.setFontSize(12);
            doc.setFont("Courier");
            doc.text(105, 32, studentResultDetails[0].academicSession);
      
            doc.setFontSize(13);
            doc.setFont("Helvetica");
            doc.text(65, 38, 'REPORT CARD FOR CLASS -');
            doc.setLineWidth(0.5);
            doc.text(130, 38, studentResultDetails[0].studiedRoman);
            doc.text(135, 38, studentResultDetails[0].classSection);
            doc.line(62, 39, 140, 39);

            doc.setFontSize(10);
            doc.setFont("helvetica");
            doc.text(20, 50, " Roll No. :");
            doc.setFontSize(12);
            doc.setFont("Courier");
            doc.text(40, 50, studentResultDetails[0].studentRollNumber);

            doc.setFontSize(10);
            doc.setFont("helvetica");
            doc.text(130, 50, " Student Id :");
            doc.setFontSize(12);
            doc.setFont("Courier");
            doc.text(155, 50, studentResultDetails[0].studentIdNumber);

            doc.setFontSize(10);
            doc.setFont("helvetica");
            doc.text(130, 57, " Date of Birth :");
            doc.setFontSize(12);
            doc.setFont("Courier");
            doc.text(160, 57, studentResultDetails[0].dateOfBirth);

            doc.setFontSize(10);
            doc.setFont("helvetica");
            doc.text(20, 57, " Student's Name :");
            doc.setFontSize(12);
            doc.setFont("Courier");
            doc.text(60, 57, studentResultDetails[0].studentName);

            doc.setFontSize(10);
            doc.setFont("helvetica");
            doc.text(20, 64, " Mother's Name :");
            doc.setFontSize(12);
            doc.setFont("Courier");
            doc.text(60, 64, studentResultDetails[0].mothersName);

            doc.setFontSize(10);
            doc.setFont("helvetica");
            doc.text(130, 64, " Father's Name :");
            doc.setFontSize(12);
            doc.setFont("Courier");
            doc.text(160, 64, studentResultDetails[0].fathersName);

            doc.setFontSize(10);
            doc.setFont("helvetica");
            doc.text(20, 73, " Term-I (100 Marks)");


            autoTable(doc, {
             margin: { top: 75 },
             theme : 'grid',
             headStyles: {
              fillColor: "#6c707b",
              fontSize: 8,
              halign: "center",
              lineColor: "#fff",
              valign: "middle",
            },            
              bodyStyles:{ halign: "center", fontSize: 8,},
              tableLineWidth : 0.1,
              tableLineColor : "#475569",
              footStyles : {fillColor : "#fff", textColor :"#000", fontSize: 9,},
              head: [[ 'S.No.','Subject Name', 'Per Test (10)', 'Note Book (05)','Subject Enrichment (05)','H.Y. Exam (80)','Marks Obtained (100)','Grade']],
              body: [
                [ '1','English', studentResultDetails[0].perTestExamEnglishTerm1, studentResultDetails[0].noteBookEnglishTerm1,studentResultDetails[0].subjectEnrichmentEnglishTerm1,studentResultDetails[0].halfYearlyExamEnglishTerm1,studentResultDetails[0].totalObtainEnglishTerm1, showGradeTerm1(studentResultDetails[0].totalObtainEnglishTerm1)],
                ['2','Hindi', studentResultDetails[0].perTestExamHindiTerm1, studentResultDetails[0].noteBookHindiTerm1,studentResultDetails[0].subjectEnrichmentHindiTerm1,studentResultDetails[0].halfYearlyExamHindiTerm1,studentResultDetails[0].totalObtainHindiTerm1, showGradeTerm1(studentResultDetails[0].totalObtainHindiTerm1)],
                [ '3','Sanskrit', studentResultDetails[0].perTestExamSanskritTerm1, studentResultDetails[0].noteBookSanskritTerm1,studentResultDetails[0].subjectEnrichmentSanskritTerm1,studentResultDetails[0].halfYearlyExamSanskritTerm1,studentResultDetails[0].totalObtainSanskritTerm1,showGradeTerm1(studentResultDetails[0].totalObtainSanskritTerm1)],
                ['4', 'Maths', studentResultDetails[0].perTestExamMathsTerm1, studentResultDetails[0].noteBookMathsTerm1,studentResultDetails[0].subjectEnrichmentMathsTerm1,studentResultDetails[0].halfYearlyExamMathsTerm1,studentResultDetails[0].totalObtainMathsTerm1,showGradeTerm1(studentResultDetails[0].totalObtainMathsTerm1)],
                ['5', 'Science', studentResultDetails[0].perTestExamScienceTerm1, studentResultDetails[0].noteBookScienceTerm1,studentResultDetails[0].subjectEnrichmentScienceTerm1,studentResultDetails[0].halfYearlyExamScienceTerm1,studentResultDetails[0].totalObtainScienceTerm1,showGradeTerm1(studentResultDetails[0].totalObtainScienceTerm1)],
                ['6', 'S.Science', studentResultDetails[0].perTestExamSocialScienceTerm1, studentResultDetails[0].noteBookSocialScienceTerm1,studentResultDetails[0].subjectEnrichmentSocialScienceTerm1,studentResultDetails[0].halfYearlyExamSocialScienceTerm1,studentResultDetails[0].totalObtainSocialScienceTerm1,showGradeTerm1(studentResultDetails[0].totalObtainSocialScienceTerm1)],
                ],
                foot : [['', 'Grade',showTotalGradeTerm1(studentResultDetails[0].totalObtainedMarksTerm1)]]
            })

   
            doc.setFontSize(10);
            doc.setFont("helvetica");
            doc.text(20, 135, " Term-II (100 Marks)");

            autoTable(doc, {
              margin: { top: 80 },
              theme : 'grid',
              headStyles: {
               fillColor: "#6c707b",
               fontSize: 8,
               halign: "center",
               lineColor: "#fff",
               valign: "middle",
             },            
             bodyStyles:{ halign: "center", fontSize: 8,},
               tableLineWidth : 0.1,
               tableLineColor : "#475569",
               footStyles : {fillColor : "#fff", textColor :"#000", fontSize: 9,},
               head: [[ 'S.No.','Subject Name', 'Per Test (10)', 'Note Book (05)','Subject Enrichment (05)','H.Y. Exam (80)','Marks Obtained (100)','Grade']],
               body: [
                 [ '1','English', studentResultDetails[0].perTestExamEnglishTerm1, studentResultDetails[0].noteBookEnglishTerm1,studentResultDetails[0].subjectEnrichmentEnglishTerm1,studentResultDetails[0].halfYearlyExamEnglishTerm1,studentResultDetails[0].totalObtainEnglishTerm1, showGradeTerm1(studentResultDetails[0].totalObtainEnglishTerm1)],
                 ['2','Hindi', studentResultDetails[0].perTestExamHindiTerm1, studentResultDetails[0].noteBookHindiTerm1,studentResultDetails[0].subjectEnrichmentHindiTerm1,studentResultDetails[0].halfYearlyExamHindiTerm1,studentResultDetails[0].totalObtainHindiTerm1, showGradeTerm1(studentResultDetails[0].totalObtainHindiTerm1)],
                 [ '3','Sanskrit', studentResultDetails[0].perTestExamSanskritTerm1, studentResultDetails[0].noteBookSanskritTerm1,studentResultDetails[0].subjectEnrichmentSanskritTerm1,studentResultDetails[0].halfYearlyExamSanskritTerm1,studentResultDetails[0].totalObtainSanskritTerm1,showGradeTerm1(studentResultDetails[0].totalObtainSanskritTerm1)],
                 ['4', 'Maths', studentResultDetails[0].perTestExamMathsTerm1, studentResultDetails[0].noteBookMathsTerm1,studentResultDetails[0].subjectEnrichmentMathsTerm1,studentResultDetails[0].halfYearlyExamMathsTerm1,studentResultDetails[0].totalObtainMathsTerm1,showGradeTerm1(studentResultDetails[0].totalObtainMathsTerm1)],
                 ['5', 'Science', studentResultDetails[0].perTestExamScienceTerm1, studentResultDetails[0].noteBookScienceTerm1,studentResultDetails[0].subjectEnrichmentScienceTerm1,studentResultDetails[0].halfYearlyExamScienceTerm1,studentResultDetails[0].totalObtainScienceTerm1,showGradeTerm1(studentResultDetails[0].totalObtainScienceTerm1)],
                 ['6', 'S.Science', studentResultDetails[0].perTestExamSocialScienceTerm1, studentResultDetails[0].noteBookSocialScienceTerm1,studentResultDetails[0].subjectEnrichmentSocialScienceTerm1,studentResultDetails[0].halfYearlyExamSocialScienceTerm1,studentResultDetails[0].totalObtainSocialScienceTerm1,showGradeTerm1(studentResultDetails[0].totalObtainSocialScienceTerm1)],
                 ],
                 foot : [['', 'Grade',showTotalGradeTerm1(studentResultDetails[0].totalObtainedMarksTerm1)]]
             })

             
            autoTable(doc, {
              theme : 'grid',
              startY: 195, 
              styles: {overflow: 'hidden'}, 
              margin: {right: 107} ,
              headStyles: {
               fillColor: "#6c707b",
               fontSize: 8,
               halign: "center",
               lineColor: "#fff",
               valign: "middle",
               lineWidth: 0.2,
               minCellHeight: 2,
             },            
             bodyStyles:{ halign: "center", fontSize: 9,},
               tableLineWidth : 0.2,
               tableLineColor : "#475569",
               footStyles : {fillColor : "#fff", textColor :"#000"},
               head: [['Co-Scholastic Areas: Term-1[on a 3-point (A-C) grading Scale','']],
               body: [
                 ['Work Education ( or Pre-Vocational Education)','A'],
                 ['Art Education','A'],
                 ['Health & Physical Education','A'],
                ],
             })


             autoTable(doc, {
              theme : 'grid',
              startY: 195, 
              styles: {overflow: 'hidden'}, 
              margin: {left: 107} ,
              headStyles: {
               fillColor: "#6c707b",
               fontSize: 8,
               halign: "center",
               lineColor: "#fff",
               valign: "middle",
               lineWidth: 0.2,
               minCellHeight: 2,
             },            
             bodyStyles:{ halign: "center", fontSize: 9,},
               tableLineWidth : 0.2,
               tableLineColor : "#475569",
               footStyles : {fillColor : "#fff", textColor :"#000"},
               head: [['Co-Scholastic Areas: Term-1[on a 3-point (A-C) grading Scale','']],
               body: [
                 ['Work Education ( or Pre-Vocational Education)','A'],
                 ['Art Education','A'],
                 ['Health & Physical Education','A'],
                ],
             })

             autoTable(doc, {
              theme : 'grid',
              startY: 225, 
              styles: {overflow: 'hidden'}, 
              margin: {right: 107} ,
              headStyles: {
               fillColor: "#6c707b",
               fontSize: 8,
               halign: "center",
               lineColor: "#fff",
               valign: "middle",
               lineWidth: 0.2,
               minCellHeight: 2,
             },            
             bodyStyles:{ halign: "center", fontSize: 8,},
               tableLineWidth : 0.2,
               tableLineColor : "#475569",
               footStyles : {fillColor : "#fff", textColor :"#000"},
               head: [['','Grade']],
               body: [
                 ['DISCIPLINE: TERM-1[ON A 3-POINT (A-C) grading scale','A']],
             })

             autoTable(doc, {
              theme : 'grid',
              startY: 225, 
              styles: {overflow: 'hidden'}, 
              margin: {left: 107} ,
              headStyles: {
               fillColor: "#6c707b",
               fontSize: 8,
               halign: "center",
               lineColor: "#fff",
               valign: "middle",
               lineWidth: 0.2,
               minCellHeight: 2,
             },            
             bodyStyles:{ halign: "center", fontSize: 8,},
               tableLineWidth : 0.2,
               tableLineColor : "#475569",
               footStyles : {fillColor : "#fff", textColor :"#000"},
               head: [['','Grade']],
               body: [
                 ['DISCIPLINE: TERM-2[ON A 3-POINT (A-C) grading scale','A']],
             })

             doc.setFontSize(11);
             doc.setFont("helvetica");
             doc.text(20, 245, "Class Teacher's Remarks  :");

             
             doc.setFontSize(9.5);
             doc.setFont("helvetica");
             doc.text(20, 250, "Promoted to class :");

             doc.setFontSize(9.5);
             doc.setFont("helvetica");
             doc.text(20, 254, "Place :");

             doc.setFontSize(9.5);
             doc.setFont("helvetica");
             doc.text(20, 258, "City :");

             
             doc.setFontSize(9.5);
             doc.setFont("helvetica");
             doc.text(20, 265, "INSTRUCTIONS");

             doc.setFontSize(9.5);
             doc.setFont("helvetica");
             doc.text(20, 268, "Grading scale for scholastic areas :     Grades are awarded on a 8-point grading scale as follows")

             doc.setFontSize(9.5);
             doc.setFont("helvetica");
             doc.text(20, 272, "MARKS RANGE & GRADES :");

            doc.save('result.pdf');    
            
        }

  return (
    <div className="p-5  min-h-screen">
    {studentResultDetails?.map((item, index) => (
 <div className="w-full p-5 text-gray-700" key={index}>
  <div className="grid grid-cols-7 gap-4">
  <div className='justify-self-end items-center' >
   <img src="../assets/sail.png" alt="pic" className='h-24 w-24' />
  </div>
  <div className="mb-2 text-center w-full col-span-5">
  <div className='mb-1 '> 
          <span className="font-bold  text-3xl ">
              BOKARO ISPAT SENIOR SECONDARY SCHOOL 8B
          </span>
  </div>
  <div className='grid grid-cols-9 gap-4'>
  <div className='mb-1 col-span-5 ml-10'> 
  <span className="text-xl ">
              BOKARO STEEL CITY, JHARKHAND (INDIA)
           </span>
  </div>
  </div>  
  <div className="flex justify-center items-center mt-6 ">
        <div className="md:w-1/5 ">
          <label
            className="block font-bold md:text-left "
          >
            Academic Session
          </label>
        </div>
        <div className="md:w-1/5">
        {item.academicSession}
        </div>
      </div>
<div className='mb-1'> 
<span className="block font-bold md:text-center mb-1 md:mb-0 pr-4 text-2xl underline underline-offset-8 ">
  REPORT CARD FOR THE CLASS-<span>{item.studiedRoman}</span>/<span>{item.classSection}</span>
  </span>
</div>
</div>
  <div className='justify-items-center items-center' >
   <img src="../assets/as_logo.png" alt="pic" className='h-24 w-24' />
  </div>
  </div>
   
  <div className="grid grid-cols-2  pl-5 pr-5 ">
          <div className="  text-black-500 text-lg font-bold text-center pt-10  ">
          <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    S.No.
                  </label>
                </div>
                <div className="md:w-2/5">
                {++index}
                </div>
              </div>
            </div>
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Roll No.
                  </label>
                </div>
                <div className="md:w-2/5">
                {item.studentRollNumber}
                </div>
              </div>
            </div>
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6 ">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Student's Name
                  </label>
                </div>
                <div className="md:w-2/5">
                {item.studentName}
                </div>
              </div>
            </div>
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                   Mother's Name
                  </label>
                </div>
                <div className="md:w-2/5">
                {item.mothersName}
                </div>
              </div>
            </div>

          </div>
          <div className=" text-black-500 text-lg font-bold text-center pt-10  pl-10 ">
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Student ID
                  </label>
                </div>
                <div className="md:w-2/5">
                  <div>{item.studentIdNumber}</div>
                </div>
              </div>
            </div>
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                   Date of Birth
                  </label>
                </div>
                <div className="md:w-2/5">
                {item.dateOfBirth}
                 </div>
              </div>
            </div>
           
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Father's Name
                  </label>
                </div>
                <div className="md:w-2/5">
                {item.fathersName}
                </div>
              </div>
            </div>
          </div>
        </div>

       <div className="mt-5">
        <div className="overflow-x-auto shadow-md sm:rounded-lg">
          <div className="text-xl text-white uppercase py-3  font-semibold bg-[#6c707b] ">
            Term-I (100 Marks)
          </div>
          <table className="min-w-full border text-center">
          <thead className="border-b ">
              <tr className="bg-gray-100">
                <th className="py-3">Subject Name</th>
                <th className="py-3">Per Test (10)</th>
                <th className="py-3">Note Book (05)</th>
                <th className="py-3">Subject Enrichment (05)</th>
                <th className="py-3">Half Yearly Exam (80)</th>
                <th className="py-3">Marks Obtained (100)</th>
                <th className="py-3">Grade</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  English
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.perTestExamEnglishTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.noteBookEnglishTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.subjectEnrichmentEnglishTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.halfYearlyExamEnglishTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainEnglishTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm1((parseFloat(item.totalObtainEnglishTerm1)/100 )*100)}
                </td>
              
              </tr>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Hindi
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {item.perTestExamHindiTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.noteBookHindiTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.subjectEnrichmentHindiTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.halfYearlyExamHindiTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainHindiTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {showGradeTerm1((parseFloat(item.totalObtainHindiTerm1)/100 )*100)}
                </td>
              
              </tr>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Sanskrit
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {item.perTestExamSanskritTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.noteBookSanskritTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.subjectEnrichmentSanskritTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.halfYearlyExamSanskritTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainSanskritTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {showGradeTerm1((parseFloat(item.totalObtainSanskritTerm1)/100 )*100)}
                </td>
              
              </tr>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Maths
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {item.perTestExamMathsTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.noteBookMathsTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.subjectEnrichmentMathsTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.halfYearlyExamMathsTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainMathsTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {showGradeTerm1((parseFloat(item.totalObtainMathsTerm1)/100 )*100)}
                </td>
              
              </tr>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Science
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {item.perTestExamScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.noteBookScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.subjectEnrichmentScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.halfYearlyExamScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {showGradeTerm1((parseFloat(item.totalObtainScienceTerm1)/100 )*100)}
                </td>
              
              </tr>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Social Science
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {item.perTestExamSocialScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.noteBookSocialScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.subjectEnrichmentSocialScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.halfYearlyExamSocialScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainSocialScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {showGradeTerm1((parseFloat(item.totalObtainSocialScienceTerm1)/100 )*100)}
                </td>
              </tr>
            </tbody>
          </table>
          <table className="min-w-full border text-center">
            <tbody>
                  <tr>
                  <td className="py-2 px-3 text-sm font-medium text-gray-900 "> 
                  Total Marks : {item.totalMarksTerm1}
                </td>
                <td className="py-2 px-1 text-sm font-medium text-gray-900 ">
                  Obtained Marks : {item.totalObtainedMarksTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 ">
                   PercentageTerm1 : {item.percentageTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 ">
                 Grade :{showTotalGradeTerm1(item.totalObtainedMarksTerm1)}

                </td>
                  </tr>
            </tbody>
          </table>
        </div>
      </div>
      </div>
    ))}
     <div className="mt-4 ">
    <button
    onClick={downloadResult}
      className="w-32 py-1.3 bg-blue-400  text-2xl text-white font-semibold"
    >
      Download
    </button>
  </div>
      </div>
  )
}

export default DownloadResult